<template>
    <span
        aria-hidden="true"
        class="v-icon notranslate mr-1 v-icon--svg theme--light"
    >
        <slot>
            <svg
                class="custom-icon"
                width="512px"
                height="512px"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
            >
                <title>{{ translations.generalSettings[lang] }}</title>
                <path
                    d="M64,144H290.75a48,48,0,0,0,90.5,0H448a16,16,0,0,0,0-32H381.25a48,48,0,0,0-90.5,0H64a16,16,0,0,0,0,32Z"
                />
                <path
                    d="M448,368H381.25a48,48,0,0,0-90.5,0H64a16,16,0,0,0,0,32H290.75a48,48,0,0,0,90.5,0H448a16,16,0,0,0,0-32Z"
                />
                <path
                    d="M448,240H221.25a48,48,0,0,0-90.5,0H64a16,16,0,0,0,0,32h66.75a48,48,0,0,0,90.5,0H448a16,16,0,0,0,0-32Z"
                />
            </svg>
        </slot>
    </span>
</template>

<script>
import translations from "@/utils/translations/global";

export default {
    name: "CustomSvg",

    mixins: [translations],

    computed: {
        lang() {
                return this.$route.params.lang;
            },
    }
};
</script>
<style lang="scss">
.custom-icon {
    fill: "secondary";
}
</style>
